<template>
    <Layout>
        <schedule :fromPreview="true" />
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import Schedule from '../../components/subpages/Schedule.vue';

export default {
    name: "SchedulePreview",
    components: { Layout, Schedule },
};
</script>